import { forwardRef } from 'react';

import pluralize from 'pluralize';

import {
  CloseDrawerButton,
  Drawer,
  DrawerProps,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';
import { Cluster } from '@cast/types';

import { DrawerContent } from 'components/drawer/ds';

type ClusterWithSchedules = Cluster & {
  schedules: {
    name: string;
  }[];
};

type AssignedSchedulesSubdrawerProps = {
  cluster: ClusterWithSchedules;
} & DrawerProps;

export const AssignedSchedulesSubdrawer = forwardRef<
  HTMLDivElement,
  AssignedSchedulesSubdrawerProps
>(({ cluster, ...props }, ref) => {
  return (
    <Drawer
      ref={ref}
      size="xsmall"
      testId="assigned-schedules-subdrawer"
      {...props}
    >
      <CloseDrawerButton />
      <DrawerContent pt={37}>
        <Typography variant="h5" mb={1}>
          Assigned schedules
        </Typography>
        <Typography variant="A1" mb={25}>
          {cluster.name}
        </Typography>
        <Typography
          variant="L12R"
          color={colorOrToken('grey.400', tokens.theme.fg.structural.secondary)}
          mb={7}
        >
          {pluralize('schedule', cluster.schedules.length, true)}
        </Typography>
      </DrawerContent>
      <Stack borderTop={tokens.theme.border.structural.neutral}>
        {cluster.schedules.map(({ name }) => (
          <Typography
            key={name}
            variant="P14R"
            py={5}
            borderBottom={tokens.theme.border.structural.neutral}
          >
            <DrawerContent component="span">{name}</DrawerContent>
          </Typography>
        ))}
      </Stack>
    </Drawer>
  );
});

AssignedSchedulesSubdrawer.displayName = 'AssignedSchedulesSubdrawer';
